import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { Card } from '../AssetCard/styled.es.js';
var AssetCardGroup = styled(Box).withConfig({
  componentId: "k0xxwj-0"
})(["width:100%;display:flex;flex-direction:column;", ":not(:last-child){margin-bottom:", ";}"], Card, spacing("xs"));
var Styled = {
  AssetCardGroup: AssetCardGroup
};
export { Styled };